import { Environment } from './environment.model';

export const environment : Environment = {
  production: true,
  apiUrl: 'https://api.foodapka.pl/',
  graphQLUrl: 'https://api.foodapka.pl/graphql/',
  baseHref: '/'
};
